import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13.912 13.919c.013 1.985 1.606 3.602 3.593 3.602 1.991 0 3.579-1.633 3.579-3.614v-.003c-.007-1.983-1.612-3.598-3.603-3.586-1.968.007-3.582 1.638-3.57 3.6Zm0 0 1-.007m-1 .007 1-.007m0 0c.01 1.447 1.167 2.609 2.593 2.609s2.579-1.172 2.579-2.614l-5.172.005Zm-4.497-.01c.012-3.953 3.183-7.134 7.092-7.142 3.893-.009 7.078 3.203 7.078 7.195 0 3.915-3.19 7.11-7.066 7.11-3.937 0-7.117-3.198-7.104-7.164ZM19.13 26.413a1.613 1.613 0 0 0-1.633-1.503l1.633 1.503Zm0 0v.138c.01 1.002-.74 1.68-1.626 1.69l.01 1m1.616-2.828-1.626 1.828m.01 1c-1.421.014-2.659-1.163-2.645-2.718m2.645 2.718a2.622 2.622 0 0 0 2.617-2.645v-.054l-5.262-.02m2.645 2.719-.01-1m-2.635-1.718a2.635 2.635 0 0 1 2.622-2.613l-2.622 2.613Zm2.635 1.718c-.858.008-1.644-.71-1.635-1.709v-.003a1.635 1.635 0 0 1 1.628-1.62l.007 3.332Z",
      stroke: "currentColor",
      strokeWidth: 2
    }))
  }));
};
export default SvgBolt;